// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../../bindings/Emotion.bs.js";
import * as Excerpt from "../../lib/Excerpt.bs.js";
import * as DateFormat from "../../lib/DateFormat.bs.js";
import * as Typography from "../Typography/Typography.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function PostTeaser$PostTeaser(props) {
  let __size = props.size;
  let id = props.id;
  let size = __size !== undefined ? __size : "standard";
  let itemStyles = Emotion.Css.css({
    borderBottom: `1px solid ` + Emotion.Utils.Color.border,
    paddingBottom: size === "featured" ? "2.5rem" : "2rem",
    marginBottom: size === "featured" ? "2.5rem" : "2rem"
  });
  let handleOpen = evt => {
    evt.preventDefault();
    RescriptReactRouter.push("/posts/" + id);
  };
  let headingSize = size === "featured" ? "3xl" : "2xl";
  let excerptLimit = size === "featured" ? 280 : 180;
  return JsxRuntime.jsxs("article", {
    children: [
      size === "featured" ? JsxRuntime.jsx(Typography.Typography.Overline.make, {
          className: Emotion.Css.css({
            marginBottom: "0.75rem",
            display: "block"
          }),
          children: "Latest"
        }) : null,
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Typography.Typography.Overline.make, {
            children: props.authorName
          }),
          JsxRuntime.jsx("span", {
            children: `\u00B7`,
            className: Emotion.Css.css({
              color: Emotion.Utils.Color.textSecondary,
              fontSize: "0.75rem"
            })
          }),
          JsxRuntime.jsx(Typography.Typography.Overline.make, {
            children: DateFormat.formatShort(props.createdAt)
          })
        ],
        className: Emotion.Css.css({
          display: "flex",
          gap: "0.5rem",
          alignItems: "center",
          marginBottom: "0.75rem"
        })
      }),
      JsxRuntime.jsx("a", {
        children: JsxRuntime.jsx(Typography.Typography.Heading.make, {
          level: "h2",
          size: headingSize,
          children: props.title
        }),
        className: Emotion.Css.css({
          color: "inherit",
          textDecoration: "none"
        }),
        href: "/posts/" + id,
        onClick: handleOpen
      }),
      JsxRuntime.jsx(Typography.Typography.Body.make, {
        className: Emotion.Css.css({
          color: Emotion.Utils.Color.textSecondary,
          margin: "0.75rem 0 0"
        }),
        children: Excerpt.fromBody(props.body, excerptLimit)
      }),
      JsxRuntime.jsx("a", {
        children: size === "featured" ? "Read the entry" : "Continue reading",
        className: Emotion.Css.css({
          display: "inline-block",
          marginTop: "1rem",
          color: Emotion.Utils.Color.primary,
          fontSize: "0.75rem",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          textDecoration: "none",
          fontWeight: "600"
        }),
        href: "/posts/" + id,
        onClick: handleOpen
      })
    ],
    className: itemStyles
  });
}

let PostTeaser = {
  make: PostTeaser$PostTeaser
};

let Typography$1;

export {
  Typography$1 as Typography,
  PostTeaser,
}
/* Emotion Not a pure module */
